/* ============================================
   SWISSSTORE.US - Main JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ============ HEADER SCROLL ============
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    header && header.classList.toggle('scrolled', window.scrollY > 50);
    document.getElementById('back-to-top')?.classList.toggle('visible', window.scrollY > 400);
  });

  // ============ BACK TO TOP ============
  document.getElementById('back-to-top')?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // ============ MOBILE MENU ============
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  const overlay = document.querySelector('.cart-drawer-overlay');

  mobileMenuBtn?.addEventListener('click', () => {
    mobileMenu?.classList.add('active');
    overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  mobileMenuClose?.addEventListener('click', closeMobileMenu);

  function closeMobileMenu() {
    mobileMenu?.classList.remove('active');
    overlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  // ============ CART DRAWER ============
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartButtons = document.querySelectorAll('[data-cart-open]');
  const cartClose = document.querySelector('.cart-close-btn');

  cartButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });

  cartClose?.addEventListener('click', closeCart);

  overlay?.addEventListener('click', () => {
    closeCart();
    closeMobileMenu();
  });

  function openCart() {
    cartDrawer?.classList.add('active');
    overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('active');
    overlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  // ============ SEARCH OVERLAY ============
  const searchOverlay = document.querySelector('.search-overlay');
  const searchBtns = document.querySelectorAll('[data-search-open]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('.search-main-input');

  searchBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      searchOverlay?.classList.add('active');
      setTimeout(() => searchInput?.focus(), 100);
    });
  });

  searchClose?.addEventListener('click', () => searchOverlay?.classList.remove('active'));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      searchOverlay?.classList.remove('active');
      closeCart();
      closeMobileMenu();
    }
  });

  // ============ CART NOTIFICATION ============
  function showCartNotification() {
    const notif = document.getElementById('cart-notification');
    if (!notif) return;
    notif.classList.add('show');
    setTimeout(() => notif.classList.remove('show'), 3000);
  }

  // ============ ADD TO CART ============
  document.querySelectorAll('.add-to-cart-btn, .product-card__add-to-cart').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId || this.closest('[data-variant-id]')?.dataset.variantId;
      if (!variantId) return;

      const originalText = this.innerHTML;
      this.innerHTML = '<span>Adding...</span>';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          showCartNotification();
          await updateCartCount();
          this.innerHTML = '<span>✓ Added!</span>';
          setTimeout(() => {
            this.innerHTML = originalText;
            this.disabled = false;
          }, 2000);
        }
      } catch (err) {
        console.error('Cart error:', err);
        this.innerHTML = originalText;
        this.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) { console.error(err); }
  }

  // ============ QUANTITY CONTROLS ============
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.quantity-control')?.querySelector('.quantity-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') val++;
      else if (this.dataset.action === 'decrease') val = Math.max(1, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  // ============ PRODUCT IMAGE GALLERY ============
  document.querySelectorAll('.product-thumbnail').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const main = document.querySelector('.product-main-image');
      if (main) main.src = this.src;
      document.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ============ TABS ============
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const tabId = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      document.getElementById(tabId)?.classList.add('active');
    });
  });

  // ============ FAQ ACCORDION ============
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ============ PRODUCT FILTER TABS ============
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ============ WISHLIST ============
  document.querySelectorAll('.wishlist-btn, .product-action-btn[data-wishlist]').forEach(btn => {
    btn.addEventListener('click', function () {
      this.classList.toggle('active');
      const icon = this.querySelector('svg, span');
      if (icon) icon.style.color = this.classList.contains('active') ? '#e53e3e' : '';
    });
  });

  // ============ COUNTDOWN TIMER ============
  function startCountdown(endDate) {
    const els = {
      days: document.getElementById('countdown-days'),
      hours: document.getElementById('countdown-hours'),
      minutes: document.getElementById('countdown-minutes'),
      seconds: document.getElementById('countdown-seconds')
    };

    function update() {
      const now = new Date().getTime();
      const diff = endDate - now;
      if (diff <= 0) { clearInterval(interval); return; }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);

      if (els.days) els.days.textContent = String(days).padStart(2, '0');
      if (els.hours) els.hours.textContent = String(hours).padStart(2, '0');
      if (els.minutes) els.minutes.textContent = String(mins).padStart(2, '0');
      if (els.seconds) els.seconds.textContent = String(secs).padStart(2, '0');
    }

    update();
    const interval = setInterval(update, 1000);
  }

  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 3);
  if (document.getElementById('countdown-days')) startCountdown(endDate.getTime());

  // ============ SCROLL ANIMATIONS ============
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.fade-up, .fade-in').forEach(el => observer.observe(el));

  // ============ ANNOUNCEMENT TICKER ============
  const ticker = document.querySelector('.announcement-bar__ticker');
  if (ticker) {
    const clone = ticker.cloneNode(true);
    ticker.parentElement.appendChild(clone);
  }

  // ============ PRODUCT VARIANT SELECTION ============
  document.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', function () {
      this.closest('.option-swatches')?.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      const label = this.closest('.product-option')?.querySelector('.option-selected');
      if (label) label.textContent = this.dataset.value || '';
    });
  });

  document.querySelectorAll('.size-option').forEach(opt => {
    opt.addEventListener('click', function () {
      this.closest('.size-options')?.querySelectorAll('.size-option').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      const label = this.closest('.product-option')?.querySelector('.option-selected');
      if (label) label.textContent = this.textContent;
    });
  });

  // ============ CHECKOUT STEPS ============
  const checkoutSteps = document.querySelectorAll('.checkout-step');
  const nextBtns = document.querySelectorAll('.checkout-next-btn');

  nextBtns.forEach((btn, i) => {
    btn.addEventListener('click', function () {
      if (checkoutSteps[i]) checkoutSteps[i].classList.remove('active');
      if (checkoutSteps[i + 1]) checkoutSteps[i + 1].classList.add('active');
    });
  });

  // ============ NEWSLETTER FORM ============
  document.querySelector('.newsletter-form')?.addEventListener('submit', function (e) {
    e.preventDefault();
    const email = this.querySelector('.newsletter-input')?.value;
    if (email) {
      this.innerHTML = '<p style="color:var(--color-accent);font-weight:600;font-size:1.1rem;">🎉 Thank you! Check your inbox for a special discount.</p>';
    }
  });

  // ============ COLOR SWATCH TOOLTIP ============
  document.querySelectorAll('.swatch[title]').forEach(swatch => {
    swatch.addEventListener('mouseenter', function () {
      const tooltip = document.createElement('span');
      tooltip.className = 'swatch-tooltip';
      tooltip.textContent = this.title;
      tooltip.style.cssText = 'position:absolute;bottom:calc(100%+6px);left:50%;transform:translateX(-50%);background:var(--color-primary);color:white;padding:4px 8px;border-radius:4px;font-size:11px;white-space:nowrap;pointer-events:none;z-index:10;';
      this.style.position = 'relative';
      this.appendChild(tooltip);
    });
    swatch.addEventListener('mouseleave', function () {
      this.querySelector('.swatch-tooltip')?.remove();
    });
  });

  // ============ STICKY ADD TO CART ============
  const productActions = document.querySelector('.product-actions');
  const stickyBar = document.querySelector('.sticky-add-to-cart');

  if (productActions && stickyBar) {
    const io = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    });
    io.observe(productActions);
  }

  // ============ IMAGE ZOOM ============
  document.querySelector('.product-main-image')?.addEventListener('mousemove', function (e) {
    const rect = this.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    this.style.transformOrigin = `${x}% ${y}%`;
  });

  document.querySelector('.product-main-image')?.addEventListener('mouseenter', function () {
    this.style.transform = 'scale(1.5)';
    this.style.transition = 'transform 0.3s ease';
    this.closest('.product-gallery')?.style?.setProperty('overflow', 'hidden');
  });

  document.querySelector('.product-main-image')?.addEventListener('mouseleave', function () {
    this.style.transform = 'scale(1)';
  });

  // Init
  updateCartCount();
});
